import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from 'store';
import {
  RegistrationStep,
  REGISTRATION_STEP,
} from '../../../constants/registrationStep';

/**
 * クローラーの登録画面の状態
 */
interface RegistrationState {
  /** 登録モーダル表示フラグ */
  isOpen: boolean;
  /** 登録ステップ */
  step: RegistrationStep;
  /** APIキーテンプレート不要チェック */
  isCheckUnnecessaryApiKey: boolean;
}

/**
 * クローラー登録画面の初期状態
 */
const initialState: RegistrationState = {
  isOpen: false,
  step: REGISTRATION_STEP.INPUT,
  isCheckUnnecessaryApiKey: false,
};

/**
 * クローラー登録画面の slice(reducer + action)
 */
export const registrationSlice = createSlice({
  name: 'registrationCrawler',
  initialState,
  reducers: {
    initialize: () => initialState,
    modalOpened: (state) => {
      state.isOpen = true;
    },
    updateStep: (
      state,
      { payload }: PayloadAction<RegistrationState['step']>,
    ) => ({
      ...state,
      step: payload,
    }),
    changeIsCheckUnnecessaryApiKey: (state) => {
      state.isCheckUnnecessaryApiKey = !state.isCheckUnnecessaryApiKey;
    },
  },
});

/**
 * クローラー登録画面の action
 */
export const registrationActions = registrationSlice.actions;

/**
 * クローラー登録画面の selectors
 */
export const registrationSelectors = {
  isOpenModal: (state: RootState) => state.crawler.registration.isOpen,
  currentModalStep: (state: RootState) => state.crawler.registration.step,
  isCheckUnnecessaryApiKey: (state: RootState) =>
    state.crawler.registration.isCheckUnnecessaryApiKey,
} as const;
